<template>
  <div class="all width98 margin-auto">
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <div class="pad-bot10 flex-betweencen f14" style="min-height: 360px">
          <div
            class="width17 backwhite margin-right20 pad-bot20 border-rd3"
            style="min-height: 360px"
          >
            <div class="white">
              <div class="detaillogo">
                <img class="logo" :src="imgurl" alt="" />
              </div>
              <p class="width100 textalign-center margin-top30">
                <span
                  class="cursorpointer attention"
                  @click="addteadmarkfollow()"
                >
                  加 入 瞭 望 台
                </span>
              </p>
              <p class="width100 textalign-center margin-top30">
                <span class="cursorpointer attention" @click="addtrand()">
                  加入我的商标
                </span>
              </p>
            </div>
          </div>

          <div
            class="width83 Retrieveform border-rd3 pad-bot20"
            style="min-height: 360px"
          >
            <table class="width96 margin-auto text-ellipsis margin-top20">
              <tr>
                <td class="tdtit">商标号码</td>
                <td class="tdcont">{{ RegNumber }}</td>
                <td class="tdtit">申请号</td>
                <td class="tdcont">{{ RegNumber }}</td>
              </tr>
              <tr>
                <td class="tdtit">国际分类</td>
                <td class="tdcont">{{ InternationalClass }}</td>
                <td class="tdtit">申请日期</td>
                <td class="tdcont">{{ ApplyDate }}</td>
              </tr>
              <tr>
                <td class="tdtit">初审日期</td>
                <td class="tdcont">{{ ApplyDate }}</td>
                <td class="tdtit">初审公告期号</td>
                <td class="tdcont">{{ FirstAnnDate }}</td>
              </tr>
              <tr>
                <td class="tdtit">注册公告日期</td>
                <td class="tdcont">{{ RegAnnDate }}</td>
                <td class="tdtit">注册公告号</td>
                <td class="tdcont">{{ RegAnnNumber }}</td>
              </tr>
              <tr>
                <td class="tdtit">商标类型</td>
                <td class="tdcont">{{ TrademarkType }}</td>
                <td class="tdtit">商标类型</td>
                <td class="tdcont">{{ GeoInfo }}</td>
              </tr>
              <tr>
                <td class="tdtit">是否驰名商标</td>
                <td class="tdcont">{{ IsWellKnown }}</td>
                <td class="tdtit">优先权日期</td>
                <td class="tdcont">{{ SpecialBeginDate }}</td>
              </tr>
              <tr>
                <td class="tdtit">是否共有商标</td>
                <td class="tdcont">{{ IsCommon }}</td>
                <td class="tdtit">是否立体商标</td>
                <td class="tdcont">{{ Is3d }}</td>
              </tr>
            </table>
            <table class="width96 margin-auto text-ellipsis">
              <tr>
                <td class="tdtit" style="border-top: none">专用权期限</td>
                <td class="tdconts" style="border-top: none">
                  {{ SpecialEndDate }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div
          class="
            Retrieveform
            pad-top20 pad-bot10
            lineheight40
            margin-top10
            border-rd3
          "
        >
          <div class="width96 margin-auto">
            <p class="Patent-abstract pad-left10 f14 dimensional">
              商标设计说明
            </p>
            <p class="f14">
              {{ TrademakDesignDesc }}
            </p>
          </div>
        </div>
        <div class="Retrieveform pad-bot10 lineheight40 border-rd3">
          <div class="width96 pad-top20 margin-auto margin-top20">
            <p class="Patent-abstract pad-left10 f14 dimensional">申请人信息</p>

            <p class="f14 flexleft pad-top20">
              <span class="tdtit" style="width: 32%">申请人中文名 </span
              ><span class="tdtit" style="width: 32%">申请人英文名 </span
              ><span class="tdtit" style="width: 32%">申请人地址</span>
            </p>
            <p class="f14 flexleft pad-bot20">
              <span class="tdcontss" style="width: 32%"
                >{{ RegisterName }} </span
              ><span class="tdcontss" style="width: 32%"
                >{{
                  RegisterEnName == null || RegisterEnName == ""
                    ? ""
                    : RegisterEnName
                }} </span
              ><span class="tdcontss" style="width: 32%">{{
                RegisterCnAddress
              }}</span>
            </p>
          </div>
        </div>
        <div class="Retrieveform pad-bot10 lineheight40 border-rd3">
          <div class="width96 pad-top20 margin-auto margin-top20">
            <p class="Patent-abstract pad-left10 f14 dimensional">代理机构</p>
            <p class="f14">
              代理机构： <span class="f14">{{ AgentName }}</span>
            </p>
          </div>
        </div>
        <div class="Retrieveform pad-bot10 lineheight35 border-rd3">
          <div class="width96 pad-top20 margin-auto margin-top20">
            <p class="Patent-abstract pad-left10 f14 dimensional">
              商标设计说明
            </p>
            <p class="f14" v-for="(it, index) in items" :key="index">
              {{ it.ItemSerial }} - {{ it.SimilarGroup }} - {{ it.RegNumber }} -
              {{ it.ItemName }}
            </p>
          </div>
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { trademarkdetail, AddTrademark } from "@/api/patent/patent.api";
import { followtrademarkfllow } from "@/api/Center/Center.api";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      name: "",
      items: "",
      TrademarkName: "",
      TrademakDesignDesc: "",
      InternationalClass: "",
      RegisterName: "",
      RegisterEnName: "",
      RegNumber: "",
      ApplyAddress: "",
      SimilarGroup: "",
      ItemName: "",
      FirstAnnNumber: "",
      FirstAnnDate: "",
      RegAnnNumber: "",
      RegAnnDate: "",
      SpecialBeginDate: "",
      SpecialEndDate: "",
      AgentName: "",
      imgurl: "",
      GeoInfo: "",
      id: "",
      ApplyDate: "",
      TrademarkType: "",
      IsCommon: "",
      Is3d: "",
      IsWellKnown: "",
      RegisterCnAddress: "",
    };
  },
  methods: {
    // 加入瞭望台
    addteadmarkfollow() {
      followtrademarkfllow({ trademark_id: this.id }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "已加入瞭望台",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 加入我的商标
    addtrand() {
      AddTrademark({
        RegNumber: this.RegNumber,
        InternationalClass: this.InternationalClass,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "已加入",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    // 获取商标详情
    trademarkdetail({
      item_key: window.sessionStorage.getItem("item_key"),
    }).then((res) => {
      if (res.data.code == 200) {
        const cont = res.data.data;
        this.TrademarkName = cont.TrademarkName;
        this.RegNumber = cont.RegNumber;
        this.RegisterName = cont.RegisterName;
        this.InternationalClass = cont.InternationalClass;
        this.ApplyAddress = cont.ApplyAddress;
        this.items = cont.items;
        this.id = cont.id;
        this.FirstAnnNumber = cont.FirstAnnNumber;
        this.FirstAnnDate = cont.FirstAnnDate;
        this.RegAnnNumber = cont.RegAnnNumber;
        this.RegAnnDate = cont.RegAnnDate;
        this.SpecialBeginDate = cont.SpecialBeginDate;
        this.SpecialEndDate = cont.SpecialEndDate;
        this.AgentName = cont.AgentName;
        this.ApplyDate = cont.ApplyDate;
        this.applicantName = cont.applicantName;
        this.SpecialBeginDate = cont.SpecialBeginDate;
        this.SpecialEndDate = cont.SpecialEndDate;
        this.TrademakDesignDesc = cont.TrademakDesignDesc;
        if (cont.register != "" || cont.register != null) {
          this.RegisterEnName = cont.register.RegisterEnName;
        } else {
          this.RegisterEnName = "";
        }
        this.RegisterCnAddress = cont.register.RegisterCnAddress;
        if (cont.GeoInfo == "") {
          this.GeoInfo = "暂无数据";
        } else {
          this.GeoInfo = cont.GeoInfo;
        }
        this.imgurl =
          "https://static-files.heimaqf.cn/sb/shangbiao-logo/" +
          this.RegNumber +
          ".jpg";
        if (cont.TrademarkType == "P") {
          cont.TrademarkType = "普通商标";
        } else {
          this.TrademarkType = "";
        }
        this.TrademarkType = cont.TrademarkType;
        if (cont.IsCommon == 0) {
          this.IsCommon = "否";
        } else {
          this.IsCommon = "是";
        }
        if (cont.Is3d == 0) {
          this.Is3d = "否";
        } else {
          this.Is3d = "是";
        }
        if (cont.IsWellKnown == 0) {
          this.IsWellKnown = "否";
        } else {
          this.IsWellKnown = "是";
        }
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
}
tr {
  width: 100%;
}
td {
  border: 1px solid #f0f0f0;
}
.tdtit {
  width: 15%;
  height: 40px;
  background: #f1f3f9;
  border: 1px solid rgba(233, 233, 233, 1);
  padding-left: 10px;
  font-size: 14px;
  color: #6a7589;
}
.tdcont {
  width: 35%;
  padding-left: 10px;
  height: 40px;
  font-size: 14px;
  color: #353a44;
}
.tdcontss {
  width: 15%;
  padding-left: 10px;
  height: 40px;
  font-size: 14px;
  color: #353a44;
  border: 1px solid rgba(233, 233, 233, 1);
  border-top: none;
}
.tdconts {
  width: 85%;
  padding-left: 10px;
  height: 40px;
  font-size: 14px;
  color: #353a44;
}
.all-title {
  height: 56px;
  line-height: 56px;
}
.Retrieveform {
  background: #fff;
}
.pagination {
  border-bottom: 1px solid #cacaca;
}
.Patent-abstract {
  border-left: 4px solid #52c5cb;
  height: 20px;
  line-height: 20px;
}

.addbut {
  color: #767676;
  margin: 5px 10px 0 0;
  padding: 3px;
  border: 1px solid #767676;
  border-radius: 3px;
  font-size: 12px;
}
.icon {
  font-size: 12px;
}
.detaillogo {
  width: 80%;
  margin: auto;
  /* min-width: 220px; */
  min-height: 220px;
  border: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.logo {
  width: 100%;
  max-height: 220px;
  /* min-height: 100px; */
  margin: 0 auto 0;
  background: white;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>